import React from 'react';
import { sanitize } from 'utils/domHelpers';

import * as S from './styles';

type MarkdownContentProps = {
  body: string;
  className?: string;
  bulletedListStyle?: boolean;
};

export const MarkdownContent: React.FC<MarkdownContentProps> = ({
  body,
  className,
  bulletedListStyle = false,
}) => (
  <S.MarkdownText
    className={className}
    bulletedListStyle={bulletedListStyle}
    dangerouslySetInnerHTML={{
      __html: sanitize(body),
    }}
  />
);
